import { render, staticRenderFns } from "./report-content.vue?vue&type=template&id=32679945&scoped=true&"
import script from "./report-content.vue?vue&type=script&lang=js&"
export * from "./report-content.vue?vue&type=script&lang=js&"
import style0 from "./report-content.vue?vue&type=style&index=0&id=32679945&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32679945",
  null
  
)

component.options.__file = "report-content.vue"
export default component.exports